import { META_DATA_CONFIG } from '@/config/metaData';

export default (pathname = '/', shoppingCartType = '') => {
  const splitNames = pathname.split('/').slice(-2).reverse();
  const pageName = splitNames.find((splitName) => splitName);
  return (
    META_DATA_CONFIG[pageName] ||
    META_DATA_CONFIG[shoppingCartType?.toUpperCase()]?.[pageName] ||
    {}
  );
};
